import React, { Component } from 'react'
import { Form, Icon, Input, Button, Row, Col, Spin } from 'antd';
import { Link } from 'react-router-dom';
const FormItem = Form.Item;

class ResetpasswordForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      conPassword:"",
      newPassword:"",
      error:""
    };
  }

  componentWillMount() {
    if(window.location.search) {
      let query = window.location.search
      let URL = new URLSearchParams(query);
      let oobCode = URL.get("oobCode")
      this.setState({oobCode})
    } else window.location.assign("/")
  }
  
  handleSubmit = (e)=>{
    const {conPassword,newPassword,oobCode} = this.state
    this.setState({error:"",success:""})
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if(!err){
        if(conPassword !== newPassword) return this.setState({error:"Password does not match"})
        this.props.resetPassword({
          oobCode,newPassword
        })
      }
    })
  }
  handleChange = (e) =>this.setState({[e.target.name]:e.target.value})
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="resetpass-form">
        <Row>
        <Col
          xs={{ span: 22, offset:1 }}
          sm={{ span: 22, offset:1 }}
          md={{ span: 10, offset: 7 }}
          lg={{ span: 10, offset: 7 }}
        >
          <Spin  indicator={<Icon type="loading" style={{ fontSize: 60 }} spin /> } spinning={this.props.loading}>
            <Form
                onSubmit={e => this.handleSubmit(e)}
                className=""
              >
                <div className="xheader">
                  <img src="../../img/logo.png" />
                  <h5>Reset Password</h5>
                </div>
                <FormItem>
                    {getFieldDecorator('newPassword', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        },
                        {
                          min: 6,
                          message: 'Password should be at least 6 characters'
                        }
                      ]
                    })(
                      <Input.Password
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('conPassword', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        },
                        {
                          min: 6,
                          message: 'Password should be at least 6 characters'
                        }
                      ]
                    })(
                      <Input.Password
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        type="password"
                        name="conPassword"
                        placeholder="Confirm Password"
                      />
                    )}
                    <span style={{color:"red"}}>{this.state.error}</span>
                  </FormItem>
                  
                  <FormItem className="login-btn">
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="xpad-btn"
                    >
                      Update Password
                    </Button>
                  </FormItem>
                  <div className="form-footer"><hr />
                       Already have an account? <span onClick={this.props.toggleModal}>Login</span>
                      <br />  Don't have an account? <Link to="/signup" className="link">Signup</Link>{' '}

                    </div>            
            </Form>
          </Spin>
        </Col>
        </Row>
      </div>
    )
  }
}

const WrappedResetpasswordForm = Form.create()(ResetpasswordForm);
export default WrappedResetpasswordForm